import styled, { css } from 'styled-components';
import { BaseTextAreaField } from 'components/Input/InputField/BaseInputField';
import { IconButton } from 'components/Input/IconButton';

// NOTE - styles must be referenced 1. here (initialization) and 2. handleOnSubmit (re-initialization)
export const cssQuestionInputDefault = css`
  overflow-y: auto;
  height: ${({ theme }) => theme.spacing['5Xl']};
  max-height: ${({ theme }) => theme.spacing['7Xl']};
  ${({ theme }) => theme.innerAlignBorder(theme.border.xs, theme.border.subtle)};
  padding-top: ${({ theme }) => theme.spacing['lg']};
  padding-right: ${({ theme }) => theme.spacing['xl']};
  padding-bottom: ${({ theme }) => theme.spacing['lg']};
  padding-left: ${({ theme }) => theme.spacing['xl']};
  :focus {
    ${({ theme }) => theme.innerAlignBorder(theme.border.xs, theme.border.primary)};
  }
`;

export const QuestionFieldWrapper = styled.div`
  position: sticky;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  border-top: ${({ theme }) => `${theme.border['xs']} solid ${theme.border.strongTransparent}`};
  padding: ${({ theme }) => `${theme.spacing['xl']} ${theme.spacing['2Xl']}`};
  background: ${({ theme }) => theme.background.default};
  form {
    #input-and-send-wrapper {
      display: flex;
      width: 100%;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm}) {
    position: fixed;
    bottom: 0;
  }
`;

export const StyledBaseInputField = styled(BaseTextAreaField)`
  ${cssQuestionInputDefault}
`;

export const StyledIconButton = styled(IconButton)<{ disabled: boolean }>`
  width: ${({ theme }) => theme.spacing['5Xl']};
  height: ${({ theme }) => theme.spacing['5Xl']};
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.background.disabled : theme.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius['md']};
  color: ${({ theme, disabled }) => (disabled ? theme.icon.disabled : theme.icon.inverse)};
  margin-left: ${({ theme }) => theme.spacing['md']};
  &:disabled:hover {
    cursor: initial;
  }
  svg {
    position: absolute;
  }
`;
